import React, { useEffect, useRef, useState } from "react";
import GrapesEditor from "./GrapesEditor";


const HTML_PROMPT = `
You are a professional front-end developer. Use only **Bootstrap 5** and internal CSS to build the layout.

Convert the uploaded image into a clean, pixel-accurate, and fully responsive **HTML + CSS page** using **Bootstrap 5** only.

✅ Layout and Design:
  - Use Bootstrap **Grid System** or **Flex utilities** for structure and alignment.
  - Ensure **accurate spacing** with Bootstrap classes (p-, m-, g-, etc.).
  - Match all **font families**, **font sizes**, **font weights**, **colors**, and **border radii** as seen in the image.
  - Use Bootstrap components and utility classes to create buttons, cards, containers, and shadows as shown.

✅ Image Handling:
  - Replace images with placeholders like: https://placehold.co/[width]x[height]
  - Maintain correct aspect ratios and layout positioning.

✅ Icon Handling:
  - Use **Google Material Icons** only.
  - Include this line in <head>:
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" crossorigin="anonymous">

✅ HTML Structure:
  - Start with <!DOCTYPE html>
  - All content must be wrapped inside: <div class="wrapper">...</div>
  - Use <style> tags inside <head> for all custom CSS.
  - Use **only internal CSS**, no external stylesheets besides Bootstrap and Google Fonts.

❌ Do NOT use custom grid frameworks or external CSS libraries.
❌ Do NOT include markdown.
❌ Do NOT include explanations or comments in the code.
`;


export default function App() {
  const [image, setImage] = useState(null);
  const [htmlResult, setHtmlResult] = useState("");
  const [selectedModel, setSelectedModel] = useState("openai");
  const [loading, setLoading] = useState(false);
  const [hasEdit, setHasEdit] = useState(false);
  const iframeRef = useRef(null);
  // Replace with your OpenAI API key - **never expose this in production!**
  
  const GEMINI_API_KEY ="AIzaSyCCf1aD2-gqRikW4ov2cKBiEgjrxwA6oGo";

  const resizeBase64Img = (base64, maxSize = 1600) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        let { width, height } = img;

        // Maintain aspect ratio
        if (width > height) {
          if (width > maxSize) {
            height = Math.round((height *= maxSize / width));
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width = Math.round((width *= maxSize / height));
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7); // Compress to 70%
        resolve(compressedBase64);
      };
      img.src = base64;
    });
  };

  const handleFileChange = (e) => {
    setHtmlResult("");
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleAnalyze = async () => {
    console.log(selectedModel,"selectedModel");
    if (!image) {
      alert("Please upload an image first!");
      return;
    }
  
    setLoading(true);
    try {
      const base64 = await resizeBase64Img(image); // returns data:image/jpeg;base64,...
      let resultHtml;
  
      if (selectedModel === "openai") {
        resultHtml = await analyzeWithGPT(image);
      } else if (selectedModel === "gemini") {
        resultHtml = await analyzeWithGemini(image);
      } else {
        throw new Error("Unknown model selected");
      }
  
      if (resultHtml) {
        setHtmlResult(resultHtml);
      } else {
        alert("No valid HTML received.");
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const analyzeWithGPT = async (imageUrl) => {
    try {
      const res = await fetch("https://api-fetch.mediadirhub.com/fetch-gpt", {
        method: "POST",
        body: JSON.stringify({
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content: [
                {
                  type: "text",
                  text: HTML_PROMPT,
                },
                {
                  type: "image_url",
                  image_url: {
                    url: imageUrl,
                  },
                },
              ],
            },
          ],
          temperature: 0.2,
        }),
      });
  
      const data = await res.json();
      let content = data?.choices?.[0]?.message?.content?.trim();
  
      if (content?.startsWith("```")) {
        content = content.replace(/```(html)?|```/g, "").trim();
      }
  
      return content;
    } catch (error) {
      console.error("GPT-4o error:", error);
      throw new Error("OpenAI analysis failed");
    }
  };


  const analyzeWithGemini = async (base64Image) => {
    try {
      const res = await fetch(`https://generativelanguage.googleapis.com/v1/models/gemini-1.5-flash:generateContent?key=${GEMINI_API_KEY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                { text: HTML_PROMPT },
                {
                  inlineData: {
                    mimeType: "image/jpeg", // or "image/png"
                    data: base64Image.replace(/^data:image\/\w+;base64,/, ""),
                  },
                },
              ],
            },
          ],
        }),
      });
      
  
      const data = await res.json();
      let content = data?.candidates?.[0]?.content?.parts?.[0]?.text?.trim();
  
      if (content?.startsWith("```")) {
        content = content.replace(/```(html)?|```/g, "").trim();
      }
  
      return content;
    } catch (error) {
      console.error("Gemini error:", error);
      throw new Error("Gemini analysis failed");
    }
  };

  
  

  useEffect(() => {
    console.log("12333");
    if (iframeRef.current && htmlResult) {
      const doc =
        iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document;
      doc.open();
      doc.write(htmlResult);
      doc.close();
    }
  }, [htmlResult]);

  const handleBuilder = () => {
    setHasEdit(true);
  };

  return (
    <>
   <nav className="navbar navbar-light border-bottom px-4 py-3">
    <div className="container">
    <a className="navbar-brand fw-bold" href="#">
    <img src="https://d2wuvg8krwnvon.cloudfront.net/newui/images/appypie_monetise.svg" style={{maxWidth: 200}} />

  </a>
  <ul className="nav">
    <li className="nav-item"><a className="nav-link text-dark" href="#">Home</a></li>
    <li className="nav-item"><a className="nav-link text-dark" href="#">Tools</a></li>
    <li className="nav-item"><a className="nav-link text-dark" href="#">Documentation</a></li>
    <li className="nav-item"><a className="nav-link text-dark" href="#">Pricing</a></li>
  </ul>
    </div>
</nav>

    <div className={` ${hasEdit ? '':'container py-5'}`}>
      
     

      {htmlResult ? (
        <div>
          {hasEdit ? (
            <section>
              <GrapesEditor
                htmlCss={htmlResult}
                setHtmlResult={setHtmlResult}
              />
            </section>
          ):
          <div className="p-5 pt-4 bg-light rounded-4">
            <div className="align-items-center d-flex justify-content-between mb-4">
            <h5 className="mb-0">Output Preview:</h5>
           <button
            className="btn btn-primary mt-0 mb-0 px-5 "
            onClick={handleBuilder}
          >
            Edit in Builder
          </button>
          {/* <button
            className="btn btn-primary mt-0 mb-0 px-5 "
            onClick={handleBuilder}
          >
            Edit with AI
          </button> */}
            </div>

          <iframe
            title="html-preview"
            style={{ width: "100%", height: "800px", border: "1px solid #ddd" }}
            ref={iframeRef}
          />
         
          </div>
          }
        </div>
      )
    :
    <div>
    <div className="hero-area text-center mb-4 p-3">
      <h2 className="fs-1 fw-bolder">Convert Image to HTML Code</h2>
      <p>Transform any image into clean, responsive HTML code in seconds</p>
    </div>

    <div
      className="upload-box mb-3 border border-2 border-light-subtle rounded text-center p-4 position-relative"
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && file.type.startsWith("image/")) {
          const dt = new DataTransfer();
          dt.items.add(file);
          const input = document.getElementById("image-upload-input");
          input.files = dt.files;
          handleFileChange({ target: input });
        }
      }}
      onClick={() => document.getElementById("image-upload-input").click()}
      style={{ cursor: "pointer" }}
    >
      <input
        id="image-upload-input"
        type="file"
        accept="image/*"
        className="d-none"
        onChange={handleFileChange}
      />

      {image ? (
        <img
          src={image}
          alt="Preview"
          className="img-fluid mx-auto d-block"
          style={{ maxHeight: "300px", objectFit: "contain" }}
        />
      ) : (
        <>
          <div className="content-wrap text-center">
          <div className="icon-wrap">
            <div className="icons"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#4285F4"><path d="M260-180q-82.92 0-141.46-57.53Q60-295.06 60-378.15q0-74.54 47.96-131.12t118.96-67.04Q246.15-666 317.12-723q70.96-57 162.88-57 108.64 0 184.32 75.68Q740-628.64 740-520v20h12.31q63.23 4.92 105.46 50.85Q900-403.23 900-340q0 66.92-46.15 113.46Q807.69-180 740.77-180H522.31Q492-180 471-201q-21-21-21-51.31v-219.08l-74 72.77-42.15-41.76L480-586.54l146.15 146.16L584-398.62l-74-72.77v219.08q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85H740q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-83-58.5-141.5T480-720q-83 0-141.5 58.5T280-520h-20.77q-56.85 0-98.04 41Q120-438 120-380t41 99q41 41 99 41h100v60H260Zm220-270Z"/></svg></div>

          </div>
          <p className="h5">Click or Drag & Drop to upload an image</p>
          <p className="text-muted small">Only PNG, JPG, JPEG — Max 5MB</p>
            <a href="#" className="btn btn-primary">Choose File</a>
          </div>
        </>
      )}
    </div>
   <div className="text-center d-flex justify-content-center align-items-center mb-4">
   {
    image && <select className="form-select w-auto me-2" onChange={(e)=> setSelectedModel(e.target.value)}>
    <option value={"openai"}>GPT 4o</option>
    <option value={"gemini"}>gemini</option>
  </select>
   }
   {image &&   <button
      className="btn btn-primary d-flex align-items-center"
      onClick={handleAnalyze}
      disabled={loading || !image}
    >
     <span className="material-icons-outlined me-2">code</span>{loading ? "Analyzing..." : "Generate HTML from Image"}
    </button>} 
   
    </div>
  

  <div className="feature-sec pt-5">
  <div className="container">
    <div className="row g-4">
      <div className="col-md-4">
        <div className="feature-card text-start">
          <span className="material-icons-outlined feature-icon">speed</span>
          <h5>Instant Conversion</h5>
          <p>Get your HTML code in seconds with our advanced conversion engine.</p>
        </div>
      </div>
      <div className="col-md-4">
        <div className="feature-card text-start">
          <span className="material-icons-outlined feature-icon">smartphone</span>
          <h5>Responsive Output</h5>
          <p>Generated code works perfectly across all devices and screen sizes.</p>
        </div>
      </div>
      <div className="col-md-4">
        <div className="feature-card text-start">
          <span className="material-icons-outlined feature-icon">code</span>
          <h5>Clean Code</h5>
          <p>Receive well-formatted, semantic HTML that's easy to customize.</p>
        </div>
      </div>
      <div className="col-md-4">
        <div className="feature-card text-start">
          <span className="material-icons-outlined feature-icon">layers</span>
          <h5>Multiple Formats</h5>
          <p>Support for various image formats including PNG, JPG, and JPEG.</p>
        </div>
      </div>
      <div className="col-md-4">
        <div className="feature-card text-start">
          <span className="material-icons-outlined feature-icon">grid_view</span>
          <h5>Batch Processing</h5>
          <p>Convert multiple images at once to save time.</p>
        </div>
      </div>
      <div className="col-md-4">
        <div className="feature-card text-start">
          <span className="material-icons-outlined feature-icon">file_download</span>
          <h5>Export Options</h5>
          <p>Download your code in different formats including HTML and JSX.</p>
        </div>
      </div>
    </div>
  </div>
</div>



    </div>
    }
    
    </div>
    <footer class="bg-light text-muted py-5 pb-3">
    <div class="container">
      <div class="row mb-4">
        <div class="col-md-3">
          <h6 class="fw-bold">ImageHTML</h6>
          <p>Transform your images into clean, responsive HTML code instantly.</p>
        </div>
        <div class="col-md-3">
          <h6>Product</h6>
          <ul class="list-unstyled small">
            <li><a href="#">Features</a></li>
            <li><a href="#">Pricing</a></li>
            <li><a href="#">Documentation</a></li>
            <li><a href="#">Updates</a></li>
          </ul>
        </div>
        <div class="col-md-3">
          <h6>Company</h6>
          <ul class="list-unstyled small">
            <li><a href="#">About</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Careers</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>
        <div class="col-md-3">
          <h6>Legal</h6>
          <ul class="list-unstyled small">
            <li><a href="#">Terms</a></li>
            <li><a href="#">Privacy</a></li>
            <li><a href="#">Security</a></li>
            <li><a href="#">Support</a></li>
          </ul>
        </div>
      </div>
      <div class="text-center small mt-4">
        <small>© 2024 ImageHTML. All rights reserved.</small>
        <div class="mt-2">
          <a href="#" class="me-2"><span class="material-icons">share</span></a>
          <a href="#" class="me-2"><span class="material-icons">public</span></a>
          <a href="#"><span class="material-icons">link</span></a>
        </div>
      </div>
    </div>
  </footer>
    </>
  );
}
